import MUIDataTable from "mui-datatables";
import React, { useState, useEffect } from "react";

import LoadingOverlay from "../LoadingOverlay";

// import SingleSelectSortField from './SingleSelectSortField';

const ProductFamilyTable = ({ props, onLoad }) => {
    const [metricTableData, setMetricTableData] = useState([]);
    const [asOfDate, setAsOfDate] = useState(new Date().toISOString().split("T")[0]);
    const [isLoading, setIsLoading] = useState(true);

    const handleDateChange = (e) => {
        setAsOfDate(e.target.value);
    };

    const handleRefreshClick = () => {
        fetchMetricsForDate(asOfDate);
    };

    const fetchMetricsForDate = (date) => {
        setIsLoading(true);
        props
            .fetchData("getproductfamilymetrics", { date })
            .then((data) => {
                const metricsData = data || [];
                setMetricTableData(formatTableData(metricsData));
            })
            .catch((error) => console.error("Error fetching metrics:", error))
            .finally(() => {
                setIsLoading(false);
                if (onLoad) onLoad();
            });
    };

    useEffect(() => {
        fetchMetricsForDate(asOfDate);
    }, []);

    const formatTableData = (data) => {
        return data.map((item) => {
            const formattedItem = {
                ...item,
                paid_customer_count: item.paid_customer_count.toLocaleString("en-US"),
                ending_carr:
                    typeof item.ending_carr === "number"
                        ? `$${item.ending_carr.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                          })}`
                        : item.ending_carr,
            };

            // Bold the Total row
            if (item.product_family === "Total") {
                formattedItem.product_family = <strong>{item.product_family}</strong>;
                formattedItem.paid_customer_count = (
                    <strong>{formattedItem.paid_customer_count}</strong>
                );
                formattedItem.ending_carr = <strong>{formattedItem.ending_carr}</strong>;
            }

            return formattedItem;
        });
    };

    const columns = [
        {
            name: "product_family",
            label: "Product Family",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        width: "50%",

                        paddingLeft: "15px",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        width: "50%",
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "paid_customer_count",
            label: "Paid Customers",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",

                        paddingRight: "15px",
                        textAlign: "right",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "200px",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "ending_carr",
            label: "Ending CARR",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "120px",

                        paddingRight: "20px",
                        textAlign: "right",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "135px",
                        textAlign: "right",
                        fontWeight: "bold",
                    },
                }),
            },
        },
    ];

    const options = {
        responsive: "standard",
        selectableRows: "none",
        filter: false,
        sort: false,
        viewColumns: false,
        print: false,
        download: false,
        search: false,
        columnOrder: null,
        fixedHeader: true,
        pagination: false,
    };

    return (
        <div className="mt-32">
            <div className="mb-4 flex items-center justify-between">
                <h2>CARR by Product Family</h2>
                <div className="flex items-center">
                    <label htmlFor="asOfDate" style={{ fontSize: "14px" }}>
                        As of Date:&nbsp;
                    </label>
                    <input
                        type="date"
                        id="asOfDate"
                        value={asOfDate}
                        onChange={handleDateChange}
                        style={{
                            border: "1px solid #ccc",
                            padding: "4px",
                            borderRadius: "4px",
                            marginRight: "8px",
                            fontSize: "14px",
                        }}
                    />
                    <button
                        onClick={handleRefreshClick}
                        title="Refresh"
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0056b3")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#007bff")}
                        style={{
                            padding: "10px",
                            marginRight: "10px",
                            borderRadius: "4px",
                            backgroundColor: "#007bff",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <i className="fas fa-sync-alt"></i>
                    </button>
                </div>
            </div>
            <div className="relative min-h-[200px]">
                {isLoading && <LoadingOverlay contained text="Loading metrics..." />}
                {metricTableData.length > 0 ? (
                    <MUIDataTable
                        data={metricTableData}
                        columns={columns}
                        options={options}
                        style={{ marginTop: "80px" }}
                        className="ngShadow"
                    />
                ) : (
                    !isLoading && <h3 className="px-2 pt-8 text-center">No metrics available.</h3>
                )}
            </div>
        </div>
    );
};

export default ProductFamilyTable;
